import { Locales } from "@/enums/enums";
import CryptoJS from "crypto-js";
import { i18n } from "@/i18n";

class TextHelper {
  CreateToken(message: string): string {
    const secret = "puuntrueincube210414";
    const hash = CryptoJS.HmacSHA256(message, secret);
    const hashInBase64 = CryptoJS.enc.Base64.stringify(hash);
    return hashInBase64;
  }
  
  GetTextByLanguage(nameTh: string, nameEn: string){
    return i18n.locale == Locales.TH ? nameTh : nameEn;
  }
}

export default new TextHelper();
